<script> 
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric"; 
import sattalep from "@/models/sattalep";
import TalepMalzemeDetay from "./talepmalzemedetay.vue";
export default {
  mixins: [apibtoast, apigeneric, sattalep],
  props: ["satdosyaId","SiradakiNo"],
  page: {
    title: "Talep",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    TalepMalzemeDetay
  },
  data() {
    return {
  
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      Id:"",
      TalepTitle:""
      
    };
  },
  watch: {
    SiradakiNo() {
     
      this.Get();
    },
  },
  methods: {
    Get() {  
   
      let Page = {
      PageNumber: "1",
      PageSize: "9999",
    }; 
this.ActionsFilterGet({Service: "ouygulama",  Page:Page,Filter:'&Kisaadi=SAT'}).then((ouygulama) => {
    if(ouygulama){
 
    this.ActionsFilterGet({Service: "ouserbirimyetki",  
    Page:Page,
    Filter:'&Uygulamaid='+ ouygulama.Data[0].Id + '&Userid='+this.UserUId}).then((ouserbirimyetki) => {
    if(ouserbirimyetki && ouserbirimyetki.Data.length > 0){
      var filter ="";
      for(var i =0; i< ouserbirimyetki.Data.length; i++){
        filter+="&Birimids="+ouserbirimyetki.Data[i].Birimid
      }
      this.ActionsFilterGet({"Service":"sattalep", "Page":this.Page,"Filter":"&Onaydurum=5" + filter}).then((res) => { 
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
 
      });
    }
});
    }
});
      this.$emit("TableUpdate");

    } 
  
  }, 
};
</script>

<template>
  <Loader>

    <b-modal
      id="talepmalzemeler"
      size="xl"
      :title="$t('satinalmatalepleri.Title')"
      title-class="font-18"
      hide-footer
    >  


      <div class="row"> 

              
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                   
                      <!--<div class="search-box me-2 mb-2 d-inline-block">
                            <div class="position-relative">
                              <input type="text" class="form-control" :placeholder="$t('satinalmatalepleri.Page.Arama')" />
                              <i class="bx bx-search-alt search-icon"></i>
                            </div>
                          </div> -->

                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end"> 
                
                    
                  </div>
                </div> 
              </div>  
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th></th>
                      <th>{{$t('satinalmatalepleri.Table.TalepAdi')}}</th>
                      <th>{{$t('satinalmatalepleri.Table.BirimAdi')}}</th> 
                      <th>{{$t('satinalmatalepleri.Table.TalepTarihi')}}</th>  
                   
                    </tr>
                  </thead>
                  <tbody v-for="Data in TableData" :key="Data.Id">
                    <tr  v-if=" Data.Aktarilacaksayisi > 0">
                      <th scope="row" class="custom-accordion">
                      <a
                        class="text-body fw-medium py-1 d-flex align-items-center"
                        data-toggle="collapse"
                        v-b-toggle="'CollapseAltTablo' + Data.Id"
                        role="button"
                        aria-expanded="false"
                        aria-controls="categories-collapse"
                      >
                        <i
                          class="mdi mdi-chevron-up accor-down-icon ms-auto"
                        ></i>
                      </a>
                    </th>
                      <th scope="row">{{ Data.Baslik }}</th>
                      <td >{{ Data.BirimAdi  }}</td>  
                      <td >{{ Data.Taleptarih | formatDateTable  }}</td>  
                 
                 
                    </tr>

                      <tr v-if=" Data.Aktarilacaksayisi > 0">
                    <td colspan="5"  > 
                      <b-collapse
                        class="collapse show"
                        :id="'CollapseAltTablo' + Data.Id"
                      >  
                        <TalepMalzemeDetay
                        :Id="Data.Id"   
                        :Dosyaid="satdosyaId"
                        :SiradakiNo="SiradakiNo"
                        @TableUpdate="Get()" 
                        />

                      </b-collapse>
                    </td>

                  </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination
                  class="pagination pagination-rounded justify-content-end mb-2"
                  v-model="DefaultPage"
                  :total-rows="Page.PageDataSize"
                  :per-page="Page.PageSize"
                  aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div> 
      


</b-modal>


  </Loader>
</template>
